// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/transformation_logs_datatable" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsTransformationLogsDatatable } from "./constants";
import type { AppsTransformationLogsDatatableParams, AppsTransformationLogsDatatableResult } from "./types";

export const getTransformationLogsDatatable = reactQueryTableFetcherAdapter(
  appsTransformationLogsDatatable,
  (
    signal: AbortSignal,
    { query, groupby, limit = 20, start = 0, sortdir, sortby }: AppsTransformationLogsDatatableParams
  ): Promise<AppsTransformationLogsDatatableResult> => {
    return fetch(
      "/apps/transformation_logs_datatable",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
